import LogoSpinner from "./logo-spinner"
import useStrings from "@/lib/hooks/useStrings"

export default function Loading() {
  const { loading } = useStrings()

  return (
    <div className="flex flex-col items-center justify-center h-full text-3xl font-libre">
      <LogoSpinner />
      <div className="flex flex-row">
        {loading}
        <span className="animate-dot" style={{ animationDelay: "600ms" }}>
          .
        </span>
        <span className="animate-dot" style={{ animationDelay: "300ms" }}>
          .
        </span>
        <span className="animate-dot">.</span>
      </div>
    </div>
  )
}
